// extracted by mini-css-extract-plugin
module.exports = {"imgWrapper":"BlockContent_imgWrapper__2qUTp","img":"BlockContent_img__1P_qu","videoText":"BlockContent_videoText__1VBGR","factbox":"BlockContent_factbox__3YwDH"};